import React, { Component } from "react";
import Axios from "axios";
import { getUser } from "../../actions/session";
import {
  CARRIER_TABLE_STATS,
  LOGIN_URL,
  ALL_CARRIER_LIST,
  SERVER_PATH,
} from "../../config/rest_endpoints";
import CustomLoader from "../common/loader";
import ReactTooltip from "react-tooltip";
import { Notifications } from "../common/notification";
import { Redirect, withRouter } from "react-router";
import MultiSelect from "@khanacademy/react-multi-select";
import { Link } from "react-router-dom";
import { CARRIER_PER_DAY } from "../routers/RouteConstants";

// datetime picker imports
import DateRangePicker from 'react-bootstrap-daterangepicker';
import moment from "moment";

class ChangeCarrierStats extends Component {
  constructor(props) {
    super(props);
    // initializing states
    this.state = {
      User: getUser(),
      data: [],
      startDate: moment(new Date()),
      endDate: moment(new Date()),
      isGetting: false,
      isGettingReport: false,
      isLoginURL: false,
      carrierList: [],
      selectedCarrier: [],
      isBtnSpin:false,
      isDownLoadSpin: false,
      expandedRows: {},
      carrierReport: []
    };
    this.getReportOnSelectDate = this.getReportOnSelectDate.bind(this);
    this.handleDate = this.handleDate.bind(this);
  }

  componentDidMount() {
    this.getReportOnSelectDate();
    this.getAllCarrierNames();
    this.setState({isBtnSpin:false, isDownLoadSpin:false})
  }

  // handle date and time on selection of datetime picker
  handleDate(date, value) {
    if (value == "start") {
      this.setState({ startDate: date }, () => {
        console.log("start", this.state.startDate);
      });
    } else {
      this.setState({ endDate: date }, () => {
        console.log("end", this.state.endDate);
      });
    }
  }

  toggleRow(rowId) {
    const { User, startDate, endDate, expandedRows } = this.state;
    let StDate = moment(startDate).format("MM/DD/YYYY, h:mm:ss A");
    let enDate = moment(endDate).format("MM/DD/YYYY, h:mm:ss A");
    const isExpanded = expandedRows[rowId];

    const selectedRow = this.state.data[rowId];

    const newExpandedRows = {};
    for (let key in expandedRows) {
        newExpandedRows[key] = false;
    }

    console.log("selectedRow", selectedRow)
    if (!isExpanded) {
      // If the row is not expanded
      const carrierID = selectedRow.carrierID;
      const url = `${SERVER_PATH}/apiv1/reporting/account/stats/carrier/${carrierID}`;
      const payload = {
        startDate: StDate,
        endDate: enDate,
        carrierID: carrierID,
      };
      this.setState({ isGettingReport: true });
      const headers = { Authorization: "Bearer " + User.token };
      Axios.post(url, payload, { headers })
        .then((res) => {
          console.log("POST request successful:", res.data);
          if (res) {
            var resp = res.data.data || [];
            this.setState({
              carrierReport: resp,
              expandedRows: {
                ...newExpandedRows,
                [rowId]: true,
              },
              isGettingReport: false
            });
          }
        })
        .catch((err) => {
          console.error("Error:", err);
        });
      this.setState({
        expandedRows: {
          ...newExpandedRows,
          [rowId]: true,
        },
        isGettingReport: true
      });
    } else {
      // If the row is expanded, simply collapse it
      this.setState({
        expandedRows: newExpandedRows,
        isGettingReport: false
      });
    }
  }

  getAllCarrierNames() {
    const { User } = this.state;

    var headers = { Authorization: "Bearer " + User.token };
    Axios.get(ALL_CARRIER_LIST, { headers })
      .then((res) => {
        if (res) {
          var resp = res.data.data;
          const list = resp.map((row) => {
            row["label"] = row["name"];
            row["value"] = row["domain"];
            return row;
          });
          this.setState({ carrierList: list });
        }
      })
      .catch((err) => {
        const alert = err.response;
        console.log(`alert.data.message`, alert.data.message);
        if (alert.data.message === "invalid or expired jwt") {
          localStorage.removeItem("user");
          this.setState({ isLoginURL: true });
          Notifications.notify(alert.data.message, "Token Expire", "error");
        }
        Notifications.notify(alert.data.message, "Failed", "error");
        this.setState({
          isGetting: false,
        });
      });
  }

  // on filter we are Carrier stats
  getReportOnSelectDate(data) {
    const { User, startDate, endDate, selectedCarrier } = this.state;
    console.log("startDate",startDate);
    var payload = {
      startDate: moment(startDate).format('MM/DD/YYYY, h:mm:ss A'),
      endDate: moment(endDate).format('MM/DD/YYYY, h:mm:ss A'),
      accounts: selectedCarrier,
    };
    console.log(`payload`, payload);
    this.setState({ isGetting: true, isBtnSpin:true, isDownLoadSpin:false });
    var headers = { Authorization: "Bearer " + User.token };
    if (data === "download") {
      this.setState({isGetting:false, isBtnSpin: false, isDownLoadSpin: true});
      Axios.post(`${CARRIER_TABLE_STATS}?download=true`, payload, { headers })
        .then((res) => {
          if (res) {
            var resp = res.data;
            const getFileName = res.headers["content-disposition"];
            const settingFileName = getFileName.replace(
              "attachment; filename=",
              ""
            );
            const url = window.URL.createObjectURL(new Blob([resp]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `${settingFileName}.csv`);
            document.body.appendChild(link);
            Notifications.notify(
              "File is been downloading...",
              "Downloading",
              "success"
            );
            link.click();
            this.setState({ isGetting: false,isBtnSpin:false, isDownLoadSpin:false });
          }
        })
        .catch((err) => {
          const alert = err.response;
          console.log(`alert.data.message`, alert.data.message);
          if (alert.data.message === "invalid or expired jwt") {
            localStorage.removeItem("user");
            this.setState({ isLoginURL: true });
            Notifications.notify(alert.data.message, "Token Expire", "error");
          }
          Notifications.notify(alert.data.message, "Failed", "error");
          this.setState({
            isGetting: false,
            isBtnSpin:false
          });
        });
    } else {
      Axios.post(CARRIER_TABLE_STATS, payload, { headers })
        .then((res) => {
          if (res) {
            var resp = res.data.data;
            this.setState({
              data: resp,
              isGetting: false,
              isBtnSpin:false
            });
          }
        })
        .catch((err) => {
          const alert = err.response;
          console.log(`alert.data.message`, alert.data.message);
          if (alert.data.message === "invalid or expired jwt") {
            localStorage.removeItem("user");
            this.setState({ isLoginURL: true });
            Notifications.notify(alert.data.message, "Token Expire", "error");
          }
          Notifications.notify(alert.data.message, "Failed", "error");
          this.setState({
            isGetting: false,
            isBtnSpin:false
          });
        });
    }
  }

  returnTotal() {
    const { data } = this.state;
    let totalRevenue = [];
    let totalCost = [];
    let totalProfit = [];
    let totalMinutes = [];
    let totalACD = [];
    let totalSDP = [];
    let totalASR = [];
    let totalCompleted = [];
    let totalOutCalls = [];
    let totalSDCount = [];

    if (data.length > 1) {
      data.forEach((item) => {
        totalRevenue.push(item["revenue"]);
        totalCost.push(item["cost"]);
        totalProfit.push(item["profit"]);
        totalMinutes.push(item["minutes"]);
        totalACD.push(item["ACD"]);
        totalSDP.push(item["SDP"]);
        totalASR.push(item["ASR"]);
        totalCompleted.push(item["completed"]);
        totalOutCalls.push(item["outCalls"]);
        totalSDCount.push(item["sdCount"]);

        // const totalMin(item['minutes'])
      });
      console.log("totalRevenue", totalRevenue);
      return (
        <tr>
          <td className="table-data"> Total</td>
          <td className="table-data"> {totalRevenue.reduce((a, b) => a + b).toFixed(4)}</td>
          <td className="table-data" > {totalCost.reduce((a, b) => a + b).toFixed(4)}</td>
          <td className="table-data"> {totalProfit.reduce((a, b) => a + b).toFixed(4)}</td>
          <td className="table-data"> {totalMinutes.reduce((a, b) => a + b).toFixed(4)}</td>
          <td className="table-data"> {totalACD.reduce((a, b) => a + b).toFixed(4)}</td>
          <td className="table-data"> {totalSDP.reduce((a, b) => a + b).toFixed(4)}</td>
          <td className="table-data"> {totalASR.reduce((a, b) => a + b).toFixed(4)}</td>
          <td className="table-data"> {totalCompleted.reduce((a, b) => a + b).toFixed(4)}</td>
          <td className="table-data"> {totalOutCalls.reduce((a, b) => a + b).toFixed(4)}</td>
          <td className="table-data"> {totalSDCount.reduce((a, b) => a + b).toFixed(4)}</td>
          <td className="table-data"></td>
          <td className="table-data"></td>
          <td className="table-data"></td>
          <td className="table-data"></td>
          <td className="table-data"></td>
          <td className="table-data"></td>
        </tr>
      );
    }
  }

  onRedirecting(data) {
    console.log('data', data)
    var id = data.carrierID;
    var Name = data.carrier;

    this.setState({ name: Name });
    if(id !== '' && Name !== '') {
      this.props.history.push(`${CARRIER_PER_DAY}/${id}/${Name}`);
    }
    else {
      Notifications.notify("Id or name not found", "Cannot Redirect", "error");
    }

  }

  renderReportTable() {
    const { data, expandedRows, carrierReport, isGettingReport } = this.state;
    console.log(data);
    if (data.length === 0 || data === null) {
      return (
        <div className="ml-3 mt-3">
          <div
            className="dataTables_info"
            id="DataTables_Table_0_info"
            role="status"
            aria-live="polite"
          >
            Showing 0 of 0 entries
          </div>
          <div
            className="dataTables_paginate paging_simple_numbers"
            id="DataTables_Table_0_paginate"
          ></div>
        </div>
      );
    } else {
      return data.map((stats, idx) => {
        const isExpanded = expandedRows[idx];
        return (
          <>
            <tr key={idx} className="left_align">
              <td className="table-data">
                <i
                  className={`icon-plus3 ml-2 ${
                    isExpanded ? "icon-minus3" : ""
                  }`}
                  style={{ cursor: "pointer" }}
                  onClick={() => this.toggleRow(idx)}
                ></i>
              </td>
              <td
                className="table-data"
                onClick={this.onRedirecting.bind(this, stats)}
              >
                <Link>{stats.carrier}</Link>
              </td>
              <td className="table-data">{stats.revenue}</td>
              <td className="table-data"> {stats.cost}</td>
              <td className="table-data">{stats.profit}</td>
              <td className="table-data">{stats.minutes}</td>
              <td className="table-data"> {stats.ACD}</td>
              <td className="table-data"> {stats.SDP}</td>
              <td className="table-data">{stats.ASR}</td>
              <td className="table-data">{stats.completed}</td>
              <td className="table-data">{stats.outCalls}</td>
              <td className="table-data">{stats.attempts_404}</td>
              <td className="table-data">{stats.attempts_487}</td>
              <td className="table-data"> {stats.attempts_4xx}</td>
              <td className="table-data">{stats.attempts_503}</td>
              <td className="table-data">{stats.attempts_5xx}</td>
              <td className="table-data">{stats.attempts_6xx}</td>
              <td className="table-data">{stats.sdCount}</td>
            </tr>
            {isExpanded && (
              <>
                {isGettingReport ? (
                  <tr>
                    <td colSpan="20" className="text-center">
                      <CustomLoader />
                    </td>
                  </tr>
                ) : (
                  <>
                    {carrierReport.length === 0 || carrierReport === null ? (
                      <tr>
                        <td
                          className="text-center"
                          style={{ backgroundColor: "#ffffff" }}
                          colSpan="20"
                        >
                          No data available
                        </td>
                      </tr>
                    ) : (
                      carrierReport.map((rowData, index) => (
                        <tr key={index} className="left_align">
                          <td className="table-data">{""}</td>
                          <td className="table-data">{rowData.accountName || 'N/A'}</td>
                          <td className="table-data">{rowData.revenue || 'N/A'}</td>
                          <td className="table-data">{rowData.cost || 'N/A'}</td>
                          <td className="table-data">{rowData.profit || 'N/A'}</td>
                          <td className="table-data">{rowData.minutes || 'N/A'}</td>
                          <td className="table-data">{rowData.ACD || 'N/A'}</td>
                          <td className="table-data">{rowData.SDP || 'N/A'}</td>
                          <td className="table-data">{rowData.ASR || 'N/A'}</td>
                          <td className="table-data">{rowData.completed || 'N/A'}</td>
                          <td className="table-data">{rowData.outCalls || 'N/A'}</td>
                          <td className="table-data">{rowData.attempts_404 || 'N/A'}</td>
                          <td className="table-data">{rowData.attempts_487 || 'N/A'}</td>
                          <td className="table-data">{rowData.attempts_4xx || 'N/A'}</td>
                          <td className="table-data">{rowData.attempts_503 || 'N/A'}</td>
                          <td className="table-data">{rowData.attempts_5xx || 'N/A'}</td>
                          <td className="table-data">{rowData.attempts_6xx || 'N/A'}</td>
                          <td className="table-data">{rowData.sdCount || 'N/A'}</td>
                        </tr>
                      ))
                    )}
                  </>
                )}
              </>
            )}
          </>
        );
      });
    }
  }

  render() {
    const {
      startDate,
      endDate,
      isGetting,
      selectedCarrier,
      carrierList,
      data,
      isBtnSpin,
      isDownLoadSpin
    } = this.state;
    if (this.state.isLoginURL === true) {
      return <Redirect to={LOGIN_URL}></Redirect>;
    }
    return (
      <div>
        <div className="">
            <div className="card-header header-elements-inline p-0 py-1 mb-1">
                <h5 style={{fontWeight:'700',fontSize:'24px'}} className="card-title"></h5>
                <div className="header-elements">
                </div>
            </div>
            <div class="d-flex justify-content-between flex-wrap bg-light rounded border p-0 mb-2 ">
              <div class=" py-2 px-3 mb-1">
                <div class="">
                  <label className="fs-14">
                    Start Date
                    <span className="text-muted "> UTC Time-zone</span>{" "}
                  </label>
                  <div class="input-group">
                  <DateRangePicker
                showWeekNumbers
                    onCallback={(date) => this.handleDate(date, "start")}
                    initialSettings={{
                      singleDatePicker: true,
                      // timePicker: false,
                      showDropdowns: true,
                      startDate: moment(startDate),
                      locale: {
                        format: 'MMMM/DD/YYYY',
                      },
                    }}
                >
                  <input  type="text" className="form-control" style={{ minWidth: '300px' }} />
                </DateRangePicker>
                  </div>
                </div>
              </div>
              <div class=" py-2 px-3 mb-1">
                <div class="">
                  <label className="fs-14">
                    End Date <span className="text-muted "> UTC Time-zone</span>{" "}
                  </label>
                  <div class="input-group">
                  <DateRangePicker
                    onCallback={(date) => this.handleDate(date, "end")}
                    initialSettings={{
                      singleDatePicker: true,
                      // timePicker: false,
                      showDropdowns: true,
                      startDate: moment(endDate),
                      locale: {
                        format: 'MMMM/DD/YYYY',
                      },
                    }}
                >
                  <input type="text" className="form-control" style={{ minWidth: '300px' }} />
                </DateRangePicker>
                  </div>
                </div>
              </div>
              <div class=" py-1 px-3 mb-1">
              <label  style={{fontWeight:'400',fontSize:'16px'}} className="">
                  Filter Carrier
                </label>
                <div class=" w-20em ">
                  <MultiSelect
                    options={carrierList}
                    selected={selectedCarrier}
                    onSelectedChanged={(selectedCarrier) =>
                      this.setState({ selectedCarrier })
                    }
                    overrideStrings={{
                      selectSomeItems: "Filter Carrier",
                      allItemsAreSelected: "All Carrier are Selected",
                      selectAll: "Select All Carrier",
                      search: "Search Carrier",
                    }}
                  />
                </div>
              </div>

              <div class="py-2 px-3 mb-1">
                <div
                  className=""
                  style={{ marginLeft: "", marginTop: "2.2em" }}
                >
                  <button
                    type="submit"
                    className="btn btn-primary main-button btn-sm "
                    onClick={this.getReportOnSelectDate}
                  >
                    Search <i class={`${isBtnSpin ? 'icon-spinner4 spinner' : 'icon-arrow-right8'} ml-2`}></i>
                  </button>
                </div>
              </div>
            </div>
            {/* row */}
            <div className="card-header header-elements-inline p-0 py-1 mb-2">
                <h5 style={{fontWeight:'700',fontSize:'24px'}} className="card-title"></h5>
                <div className="header-elements">
                <button
                    type="submit"
                    className="btn btn-success main-button "
                    onClick={this.getReportOnSelectDate.bind(this, "download")}
                  >
                    Download CSV <i class={`${isDownLoadSpin ? 'icon-spinner4 spinner' : 'icon-download7' } ml-2`}></i>
                  </button>
                </div>
            </div>
          <div className="">
            <div
              className="table-responsive "
              style={{
                overflowX: "auto",
                overflowY: "auto",
                maxHeight: "56em",
              }}
            >
              <table  className="table-style table table-striped dataTable no-footer">
                <thead>
                  <tr className="stickeyHeader table-heading-style">
                    <th></th>
                    <th>Carrier</th>
                    <th>Revenue</th>
                    <th>Cost</th>
                    <th>Profit</th>
                    <th>Minutes</th>
                    <th>ACD</th>
                    <th>SDP</th>
                    <th>ASR</th>
                    <th>Completed</th>
                    <th>Out Calls</th>
                      <th>404 Calls</th>
                      <th>487 Calls</th>
                    <th>4XX Calls</th>
                      <th>503 Calls</th>
                    <th>5XX Calls</th>
                    <th>6XX Calls</th>
                    <th>SD Count</th>
                  </tr>
                </thead>
                <tbody>
                  {isGetting ? <CustomLoader /> : this.renderReportTable()}
                  {data.length > 0 ? this.returnTotal() : ""}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <ReactTooltip
          type="info"
          backgroundColor="#4caf50"
          place="top"
          effect="solid"
        />
      </div>
    );
  }
}
export default withRouter(ChangeCarrierStats);
